import logoutIcon from "../../assets/icons/logout.svg";
import {
  LocationIcon,
  MailIcon,
  PhoneIcon
} from "../../front-end-global-components/assets/assets";
import CheckBox from "../../front-end-global-components/components/CheckBox/CheckBox";
import RoundedProfilePicture from "../../front-end-global-components/components/RoundedProfilePicture/RoundedProfilePicture";

export const ClinicCard = (props) => {
  return (
    <>
      <section className="padding-larger padding-right-larger padding-top-large padding-bottom-large">
        <div className="display-flex flex-align-items-center flex-justify-content-space-between">
          <div className="display-flex flex-align-items-center">
            <div>
              <RoundedProfilePicture
                userType="corporate"
                src={props.logoURL}
                // loading={loading}
                size="small"
              />
            </div>
            <div
              className={`padding-left-default ${
                props.boldName ? "font-family-gilroy-bold" : ""
              }`}
            >
              {props.clinicDetails?.identifier?.name
                ? props.clinicDetails?.identifier?.name
                : props.clinicDetails?.identifier?.id}
            </div>
          </div>

          <div className="font-size-small">
            {props.clinicDetails?.city ? props.clinicDetails.city : ""}
          </div>
        </div>
        <div className="font-size-small">
          <div className="padding-top-large display-flex flex-align-items-center">
            <PhoneIcon />
            <div className="padding-left-large">
              {props.clinicDetails?.telephone
                ? props.clinicDetails.telephone
                : "-"}
            </div>
          </div>

          <div className="padding-top-default display-flex flex-align-items-center">
            <MailIcon />
            <div className="padding-left-large">
              {props.clinicDetails?.email ? props.clinicDetails?.email : "-"}
            </div>
          </div>

          <div className="padding-top-default display-flex ">
            <LocationIcon width="12" />
            <div className="padding-left-large">
              {props.clinicDetails?.address ? props.clinicDetails.address : "-"}
            </div>
          </div>
        </div>
      </section>
      <hr className="background-color-lite-grey height-1px border-none" />
    </>
  );
};

// { data, loading, checkBoxOnChange }
export const DocumentCard = (props) => {
  return (
    <div className="display-flex padding-bottom-larger">
      {props.checkBoxOnChange && (
        <div className="flex-center-children-vertically">
          <CheckBox
            name={props.checkBoxName}
            data-cy="care-context-check-box"
            onChange={props.checkBoxOnChange}
            checked={props.checkBoxChecked}
          />
        </div>
      )}
      <div className="text-transform-capitalize padding-left-large flex-direction-column">
        <div className="font-size-small padding-bottom-default">
          {props.loading ? "" : props.data.display}
        </div>
        <div className="font-size-smaller background-color-secondary font-color-secondary border-radius-default width-fit-content padding-left-default padding-right-default padding-top-small padding-bottom-small">
          {props.loading ? "" : props.data.referenceNumber}
        </div>
      </div>
    </div>
  );
};

export const LogoutCard = (props) => {
  return (
    <div
      className="background-color-white padding-left-larger padding-right-larger padding-top-large padding-bottom-large display-flex flex-align-items-center border-top-2px-solid-e5e5e5 cursor-pointer"
      data-cy="LOGOUT-PROFILE"
      onClick={props.onclick}
    >
      <div className="flex-grow-1 flex-direction-column display-flex font-color-red">
        <span className="font-size-medium font-family-gilroy-regular">
          Logout Profile
        </span>
        <span className="font-size-small font-family-gilroy-regular text-transform-capitalize padding-top-small">
          Conclude your session on Ninto
        </span>
      </div>
      <img src={logoutIcon} alt="Logout" className="height-width-16px" />
    </div>
  );
};
